<template>
  <div class="notice-wrapper">
    <div class="icon-notice">
      <img
        src="@/basa/assets/images/noticeIcon.png"
        style="width: 16px; height: 16px;"
        alt=""
      />
      <div class="title">通知公告</div>
    </div>

    <div class="notice-scroll">
      <div class="blick"></div>
      <div
        class="notice-content"
        :style="{ animationDuration: duration + 's' }"
      >
        <div
          @click="check(item)"
          class="notice-item"
          v-for="item in noticeData"
          :key="item.id"
        >
          【最新公告】 {{ item.title }}
          <span class="notice-time" style="color: #999999; margin-left:8px;">{{
            item.timeBefore
          }}</span>
        </div>
      </div>
    </div>
    <el-link
      :underline="false"
      type="info"
      class="notice-more"
      @click="handleViewAll()"
    >
      更多 ></el-link
    >
  </div>
</template>
<script>
import { qryWorkDynamicsList } from "@/app/shop/api/shopping";
export default {
  name: "topNotice",
  data() {
    return {
      duration: 45, // 动画持续时间，单位秒
      noticeData: []
    };
  },
  mounted() {},
  activated() {
    this.init();
  },
  deactivated() {
    this.dividerList = [];
  },
  methods: {
    init() {
      // 查询宣传海报
      qryWorkDynamicsList({
        pageSize: 5,
        pageNo: 1,
        title: "",
        author: "",
        publishedBy: "",
        updateTimeMore: "",
        updateTimeLess: "",
        type: 0,
        agentId: 100125
      }).then(res => {
        if (res.data.code === "0") {
          console.log(res.data.data, "topNotice");
          this.noticeData = res.data.data.rows;
          this.noticeData.forEach(item => {
            if (item.title.length > 10) {
              item.title = item.title.substr(0, 30) + "...";
            }
          });
        }
      });
    },
    //查看
    check(row) {
      //评标结果、采购公告
      this.$router.push({
        path: "/announcementDetail",
        query: {
          noticeId: row.noticeId,
          id: row.id,
          schemeId: row.schemeId,
          source: "-1",
          type: row.type,
          interfaceType: this.interfaceType,
          publishedBy: row.publishedBy || "",
          activeIndex: this.activeIndex
        }
      });
    },
    //更多 >
    handleViewAll() {
      this.$router.push({
        path: "/announcementsList",
        query: {
          source: "-1",
          type: "0"
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.notice-wrapper {
  position: relative;
  display: flex;
  width: 1180px;
  height: 40px;
  margin-top: 10px;
  background: #ffffff;
  .icon-notice {
    display: flex;
    width: 77px;
    height: 30px;
    padding: 10px 5px 0 22px;
    background: #ffffff;
    .title {
      width: 56px;
      margin-left: 5px;
      line-height: 16px;
      font-family: AlimamaShuHeiTi, AlimamaShuHeiTi;
      font-weight: bold;
      font-size: 14px;
      color: #4a4a4a;
      text-align: left;
      font-style: normal;
    }
  }

  .notice-scroll {
    position: relative;
    width: 693px;
    overflow: hidden;
    background: #ffffff;
    line-height: 38px;
    .notice-content {
      white-space: nowrap;
      display: inline-block;
      animation-name: scroll;
      animation-timing-function: linear;
      animation-iteration-count: infinite;
      animation-delay: 1s;
      .notice-item {
        font-family: PingFangSC, PingFang SC;
        display: inline-block;
        margin-right: 30px;
        font-weight: 400;
        font-size: 14px;
        color: #4a4a4a;
        line-height: 20px;
        text-align: left;
        font-style: normal;
        .notice-time {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 12px;
          color: #999999;
          line-height: 17px;
          text-align: left;
          font-style: normal;
        }
      }
      .notice-item:hover {
        color: #0089ef;
        cursor: pointer;
      }
    }
    .notice-content:hover {
      animation-play-state: paused;
    }
    .blick {
      position: absolute;
      top: 0px;
      left: 0px;
      height: 40px;
      width: 40px;
      // background: linear-gradient(to right, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0));
    }
  }
  .notice-more {
    position: absolute;
    top: 4px;
    right: 335px;
    line-height: 30px;
    &:hover {
      color: #0089ef;
    }
  }
}

@keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
  // from { transform: translateX(0); }
  // to { transform: translateX(-100%); }
}
</style>
